import { Vector2 } from 'three';
import {
  ContextMenuContext,
  useContextMenuStore,
} from '@/modules/contextMenu/useContextMenuStore';
import { ConnectionDirections } from '@/modules/contextMenu/types';
import { IContextMenuService } from './IContextMenuService';

export class ContextMenuServiceImpl implements IContextMenuService {
  private contextMenuStore: typeof useContextMenuStore;

  constructor(contextMenuStore: typeof useContextMenuStore) {
    this.contextMenuStore = contextMenuStore;
  }

  setPosition(position: Vector2 | null): void {
    this.contextMenuStore.getState().setPositionState(position);
  }

  setContext(context: ContextMenuContext): void {
    this.contextMenuStore.getState().setContextState(context);
  }

  setRelatedComponentId(id: string | undefined): void {
    this.contextMenuStore.getState().setRelatedComponentIdState(id);
  }

  setRelatedControlPoint(
    controlPoint: { elementId: string; pointIndex: number } | undefined,
  ): void {
    this.contextMenuStore.getState().setRelatedControlPointState(controlPoint);
  }

  setRelatedAreaIds(ids: string[]): void {
    this.contextMenuStore.getState().setRelatedAreaIdsState(ids);
  }

  setActiveConnectionTab(tab: ConnectionDirections | undefined): void {
    this.contextMenuStore.getState().setActiveConnectionTabState(tab);
  }

  reset(): void {
    this.contextMenuStore.getState().reset();
  }
}
